import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/Header";
import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import LeftNav from "../components/LeftNav";
import Patientinfo from "../components/Patientinfo";
import { FaPlusCircle } from "react-icons/fa";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Select from "react-dropdown-select";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import { BiXCircle } from "react-icons/bi";
import DatePicker from "react-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import { AiFillAlert } from "react-icons/ai";
import { Pagination } from "@material-ui/lab";
import { activeStatus } from "../Util/OtherList";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "react-loader-spinner";

import { apiAxios } from "../Util/ApiAxios";
import moment from "moment";
import {
  FormControl,
  MenuItem,
  Dialog,
  IconButton,
  Typography,
  Grid,
} from "@mui/material";
import { AddCircleOutline, Delete } from "@material-ui/icons";
import ViewRecord from "./ViewRecord";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PatientDocument() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("false");
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [documentList, setDocumentList] = React.useState("");
  const [message2, setMessage2] = React.useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [source, setSouce] = React.useState("");
  const [uploadeFile, setUploadedFile] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [rows, setRows] = useState([{ key: "", value: "" }]);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [docName, setDocName] = React.useState("");
  const [instruction, setInstruction] = React.useState("");
  const [reportDate, setReportDate] = React.useState(null);
  const [view, setView] = React.useState(null);

  const [docNameError, setDocNameError] = React.useState(false);
  const [uploadDocError, setUploadDocError] = React.useState(false);
  const [uploadDocError2, setUploadDocError2] = React.useState(false);
  const [sourceError, setSourceError] = React.useState(false);
  const [reportDateError, setReportDateError] = React.useState(false);
  const [insructionError, setInstructionError] = React.useState("");
  const [docType, setDocType] = useState("Documents");
  const [sortOrder, setSortOrder] = useState("Sort Descending");
  const [modalDocType, setModalDocType] = useState("Documents");

  const [docName2, setDocName2] = useState("");
  const [uploadedFile2, setUploadedFile2] = useState("");
  const [docNameError2, setDocNameError2] = useState("");
  const [docID, setDocId] = useState("");
  const [isDocModalOpen2, setDocModalOpen2] = useState(false);
  const [loading, setLoading] = useState(false);

  const renderDropdown = (label, options, value, onChange, isbgwhite) => (
    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
      {label && (
        <div
          style={{
            fontSize: "13px",
            fontWeight: 500,
            color: isbgwhite ? "white" : "#114ebd",
            marginBottom: "6px",
          }}
        >
          {label} <span style={{ color: isbgwhite ? "white" : "red" }}>*</span>
        </div>
      )}
      <Select
        options={options.map((opt) => ({ label: opt, value: opt }))}
        values={value ? [{ label: value, value: value }] : []}
        onChange={(val) => onChange(val[0]?.value || "")}
        className={classes.select}
        dropdownGap={2}
        dropdownHeight="150px"
        color="#114ebd"
      />
    </FormControl>
  );

  const documentTypes = ["Documents", "Lab Reports", "Prescriptions"];
  const sortOptions = ["Sort Descending", "Sort Ascending"];
  const [isPreviewModalOpen, setPreviewModalOpen] = useState(false);
  const [uri, setUri] = useState("");

  const docTypeMap = {
    Documents: { type_of_document: "doc", list_type: "document" },
    "Lab Reports": { type_of_document: "lab", list_type: "lab" },
    Prescriptions: { type_of_document: "pres", list_type: "prescription" },
  };

  let pd = JSON.parse(localStorage.getItem("dhct_patient"));

  useEffect(() => {
    getDocList();
  }, [docType, sortOrder]);

  const getDocList = useCallback(
    async ({
      table_config_rows_per_page = "15",
      table_config_page_no = "1",
    } = {}) => {
      setCurrentPage(parseInt(table_config_page_no));
      setDocumentList([]);
      setMessage2("Loading...");

      const data = {
        table_config_page_no,
        table_config_rows_per_page,
        pd_id: pd.pd_id,
        doc_type: docTypeMap[docType].list_type
          ? docTypeMap[docType].list_type
          : "",
        sort: sortOrder === "Sort Descending" ? "DESC" : "ASC",
        appointment_id: "",
      };

      apiAxios
        .post("/report/docs/list", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((resp) => {
          if (resp.data?.statusCode === 200) {
            setDocumentList(resp.data.body);
            setTotalPages(resp.data.total_pages || 1);
            // setMessage2(resp.data.data.length > 0 ? "" : "No Data Found");
          } else {
            setMessage2("No Data Found");
          }
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
          // localStorage.clear();
          // window.location.href = "/";
        })
        .finally(() => {
          setMessage2("");
        });
    }
  );

  // const handleView = (selected) => {
  //   setView(selected);
  //   setOpen(true);
  // };
  const handleClickOpenAdd = () => {
    setOpen2(true);
    setModalDocType("Documents");
  };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const addNewRow = () => {
    setRows([...rows, { key: "", value: "" }]);
  };
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const deleteRow = (r) => {
    const updatedRow = rows.filter((_, i) => i !== r);
    setRows(updatedRow);
  };

  const blobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result.split(",", 2)[1]);
      };
    });
  };
  const submit = async () => {
    if (!docName) setDocNameError(true);
    if (!instruction) setInstructionError(true);
    if (!modalDocType) setSourceError(true);
    if (!reportDate) setReportDateError(true);
    // if (!uploadeFile) setUploadDocError(true);
    if (uploadeFile) {
      const allowedExtensions = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpg",
        "jpeg",
        "png",
        "webp",
      ];
      const extension = uploadeFile.name.split(".").pop().toLowerCase();
      if (uploadeFile.size > 5242880) {
        setUploadDocError(true);
      } else if (!allowedExtensions.includes(extension)) {
        setUploadDocError(true);
      }
    }
    // if (rows.some((row) => !row.key && !row.value)) setRowsError(true);

    if (docName && modalDocType && reportDate && instruction) {
      setShowLoader(true);
      try {
        const finalTags = [
          {
            key: "testname",
            value: `${docName}${/(?:\.([^.]+))?$/.exec(uploadeFile.name)?.[0]}`,
          },
          { key: "instructions", value: instruction },
          ...rows.filter((tag) => tag.key && tag.value),
        ];
        let data = {
          pd_id: pd.pd_id,
          file_name: uploadeFile
            ? `${docName}${/(?:\.([^.]+))?$/.exec(uploadeFile.name)?.[0]}`
            : "",
          document_type: docTypeMap[modalDocType].type_of_document,
          report_date: reportDate
            ? moment(reportDate).format("YYYY-MM-DD")
            : null,
          file: uploadeFile ? await blobToBase64(uploadeFile) : "",
          tags: finalTags,
          doc_type: docTypeMap[modalDocType].list_type,
          sort: sortOrder === "Sort Descending" ? "desc" : "asc",
          source: "Medical History",
          appointment_id: "",
        };

        const response = await apiAxios.post("/report/docs/upload", data, {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        });

        if (response.data.statusCode === 200) {
          toast.success("Document uploaded successfully!");
          setOpen2(false);
          getDocList();
        } else {
          toast.error(response.data.message || "Failed to upload document.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
        console.error(error);
      } finally {
        setShowLoader(false);
        setDocName("");
        setSouce("");
        setUploadedFile("");
        setRows([{ key: "", value: "" }]);
        setInstruction("");
        setReportDate(null);
        setModalDocType("");
      }
    }
  };
  const closeDocModal = () => {
    setDocName("");
    setInstruction("");
    setReportDate(null);
    setModalDocType("Documents");
    setUploadedFile(null);
    setRows([{ key: "", value: "" }]);
    setOpen2(false);

    setSourceError("");
    setDocNameError("");
    setReportDateError("");
    setInstructionError("");
  };

  // const downloadFile = async (presigned_uri) => {
  //   try {
  //     let data = {
  //       pd_id: pd.pd_id,
  //       presigned_uri: presigned_uri,
  //     };
  //     const response = await apiAxios.post("/report/docs/view", data, {
  //       headers: {
  //         Authorization: localStorage.getItem("dhct_Token"),
  //       },
  //     });
  //     if (response.data.statusCode === 200) {
  //       const link = document.createElement("a");
  //       link.href = response.data.body;
  //       link.target = "_blank";
  //       link.download = "";
  //       link.click();
  //     } else {
  //       toast.error(response.data.message || "Failed to Download document.");
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred. Please try again.");
  //     console.error(error);
  //   } finally {
  //     setShowLoader(false);
  //   }
  // };

  const addDocumnet = async () => {
    setLoading(true);
    try {
      setDocNameError2("");

      const trimDocName2 = docName2.trim();

      let hasError = false;
      if (!trimDocName2) {
        setDocNameError2("Document name is required.");
        hasError = true;
      }
      const allowedExtensions = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpg",
        "jpeg",
        "png",
        "webp",
      ];
      if (!uploadedFile2) {
        setUploadDocError2("Please select a document to upload.");
        hasError = true;
      } else {
        const extension = uploadedFile2.name.split(".").pop().toLowerCase();

        if (uploadedFile2.size > 5242880) {
          setUploadDocError2(true);
          hasError = true;
        } else if (!allowedExtensions.includes(extension)) {
          setUploadDocError2(true);
          hasError = true;
        } else {
          setUploadDocError2("");
        }
      }

      if (hasError) return;
      let data = {
        pd_id: pd.pd_id,
        file_name: `${docName2}${
          /(?:\.([^.]+))?$/.exec(uploadedFile2.name)?.[0]
        }`,
        file: uploadedFile2 ? await blobToBase64(uploadedFile2) : "",
        docs_id: docID ? docID : "",
        appointment_id: "",
      };
      const response = await apiAxios.post("/report/docs/update", data, {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("dhct_Token"),
        },
      });
      if (response.data.statusCode === 200) {
        toast.success("Document uploaded successfully!");
        setUploadedFile2(false);
        setDocModalOpen2(false);
        getDocList();
      } else {
        toast.error(response.data.message || "Failed to upload document.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const closeDocModal2 = () => {
    setDocName2("");
    setDocModalOpen2(false);
    setDocNameError2("");
    setUploadDocError2("");
  };

  const getPresignedUrl = async (presigned_uri) => {
    try {
      let data = {
        pd_id: pd.pd_id,
        presigned_uri: presigned_uri,
      };
      const response = await apiAxios.post("/report/docs/view", data, {
        headers: {
          Authorization: localStorage.getItem("dhct_Token"),
        },
      });

      if (response.data.statusCode === 200) {
        return response.data.body;
      } else {
        toast.error(response.data.message || "Failed to fetch document URL.");
        return null;
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error(error);
      return null;
    }
  };

  const getTagValue = (tags, key) =>
    tags.find((tag) => tag.key.toLowerCase() === key.toLowerCase())?.value ||
    "-";

  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <Header />
      <Box className={classes.Pagecontent}>
        <Box className={classes.Leftcol}>
          <Box className={classes.leftnav}>
            <Patientinfo />
            {/* left Accordion*/}
            <Box className={classes.TabPatientinfo}>
              <LeftNav />
            </Box>
          </Box>
        </Box>
        {/* right col */}
        <Box className={classes.Rightcol}>
          <Box className={classes.Tabcol}>
            <Box className={classes.Careplan}>
              <Box className={classes.plantop}>
                <h3 className={classes.topheading}> Patient's Documents</h3>
                <Button
                  className={classes.recordbtn}
                  aria-label="Add Documents"
                  onClick={handleClickOpenAdd}
                >
                  <FaPlusCircle className={classes.addicon} /> Add Documents
                </Button>
              </Box>
              <Box>
                <Grid container spacing={2} mb={2}>
                  <Grid item xs={6}>
                    {renderDropdown(
                      "Document Type",
                      documentTypes,
                      docType,
                      setDocType
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    {renderDropdown(
                      "Sort Order",
                      sortOptions,
                      sortOrder,
                      setSortOrder
                    )}
                  </Grid>
                </Grid>
              </Box>
              <Box className={classes.MedicationTable}>
                <Box className={classes.throw}>
                  <Box className={classes.Row1}> Date Uploaded</Box>
                  <Box className={classes.Row2}>Uploaded By</Box>
                  <Box className={classes.Row3}>Documnent Name</Box>
                  <Box className={classes.Row3}>Instruction</Box>
                  <Box className={classes.Row4}>Status</Box>
                  <Box className={classes.Row5}>Action</Box>
                </Box>
                {documentList && documentList?.length > 0 ? (
                  <>
                    {documentList.map((each) => (
                      <Accordion
                        key={each.docs_id}
                        expanded={expanded == each.id ? true : false}
                        onChange={handleChange(each.id)}
                        style={{ boxShadow: "none" }}
                      >
                        <AccordionSummary
                          expandIcon={<FaPlusCircle />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                          paddingLeft={40}
                        >
                          <Box className={classes.tdrow}>
                            <Box className={classes.Row1}>
                              {`${each?.report_date}`.split(" ")[0]}
                            </Box>
                            <Box className={classes.Row2}>
                              {each.uploaded_by}
                            </Box>
                            <Box className={classes.Row3}>
                              {`${each?.file_name}`.split(".")[0] ||
                                getTagValue(each.tags, "testname")}
                            </Box>
                            <Box className={classes.Row3}>
                              {getTagValue(each.tags, "instructions")}
                            </Box>
                            <Box className={classes.Row4}>{each?.status}</Box>
                            <Box className={classes.Row5}>
                              <div className="flex-shrink-0 flex flex-col gap-2 md:items-end">
                                {each.status === "requested" ? (
                                  <Box className={classes.text}>
                                    Document Requested
                                  </Box>
                                ) : (
                                  <Box className="flex">
                                    <Button
                                      className={classes.viewbtn}
                                      onClick={() => {
                                        setDocId(each.docs_id);
                                        setDocName2(
                                          each.file_name.split(".")[0] ||
                                            getTagValue(each.tags, "testname")
                                        );
                                        setUploadedFile2(null);
                                        setDocModalOpen2(true);
                                        // setSelectedDoc(each);
                                      }}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      // onClick={() => handleView(each)}
                                      onClick={async () => {
                                        const finalURL = await getPresignedUrl(
                                          each.presigned_uri
                                        );
                                        setUri(finalURL);
                                        setPreviewModalOpen(true);
                                      }}
                                      // variant="contained"
                                      className={classes.viewbtn}
                                    >
                                      View
                                    </Button>
                                  </Box>
                                )}
                              </div>
                            </Box>
                          </Box>
                        </AccordionSummary>
                      </Accordion>
                    ))}
                  </>
                ) : (
                  <Box style={{ padding: "5%", textAlign: "center" }}>
                    {message2 ? message2 : "No Data Found"}
                  </Box>
                )}
              </Box>
            </Box>
            <br /> <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "right",
                justifyContent: "right",
              }}
            >
              <Pagination
                count={totalPages}
                color="primary"
                page={currentPage}
                onChange={(event, pageNumber) =>
                  getDocList({
                    table_config_page_no: `${pageNumber}`,
                  })
                }
              />
            </div>
          </Box>
          {isPreviewModalOpen && (
            <ViewRecord
              isOpen={isPreviewModalOpen}
              onClose={() => setPreviewModalOpen(false)}
              record={uri}
            />
          )}
          {/* tab with accordion */}
        </Box>
        {/* modal */}
        <Dialog
          className={classes.modal}
          open={open2}
          TransitionComponent={Transition}
          keepMounted
          onClose={closeDocModal}
          disableEnforceFocus={true}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className={classes.ccmmodal}>
            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                fontFamily: "poppins",
                marginBottom: 30,
                fontWeight: "600",
              }}
            >
              Add Documents
            </Typography>
            <Box className={classes.btncol}>
              <Button onClick={closeDocModal} className={classes.closebtn}>
                <BiXCircle className={classes.closeicon} />
              </Button>
            </Box>
            <DialogContentText id="alert-dialog-slide-description">
              <form>
                <ul className={classes.Editplan}>
                  <li>
                    <Typography variant="p">
                      Documnet Name<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>{" "}
                    <TextField
                      placeholder="please mention medication name"
                      className={classes.input}
                      onChange={(e) => setDocName(e.target.value)}
                      value={docName}
                      type="text"
                    />
                  </li>
                  {docNameError ? (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Document name is mandatory(max character limit is 100)
                    </p>
                  ) : (
                    <></>
                  )}
                  <li>
                    <Typography variant="p">
                      Instruction<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>{" "}
                    <TextField
                      placeholder="please enter instruction"
                      className={classes.input}
                      onChange={(e) => setInstruction(e.target.value)}
                      value={instruction}
                      type="text"
                    />
                  </li>
                  {insructionError ? (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Instruction is mandatory(max character limit is 100)
                    </p>
                  ) : (
                    <></>
                  )}
                  <li>
                    <Typography variant="p">
                      Document Types<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>
                    <Box>
                      {renderDropdown(
                        "Document Type",
                        documentTypes,
                        modalDocType,
                        setModalDocType,
                        true
                      )}
                    </Box>
                  </li>
                  {sourceError ? (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Source is mandatory.
                    </p>
                  ) : (
                    <></>
                  )}

                  <li>
                    <Typography variant="p">
                      Report Date<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>
                    <Box className={classes.Enddate}>
                      <DatePicker
                        className={classes.input}
                        placeholder="Report Date"
                        maxDate={moment().toDate()}
                        clearIcon={null}
                        value={reportDate}
                        onChange={(date) => {
                          console.log("Selected date:", date);
                          setReportDate(date);
                        }}
                      />
                    </Box>
                  </li>
                  {reportDateError ? (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Report Date is mandatory
                    </p>
                  ) : (
                    <></>
                  )}
                  <li>
                    <Typography variant="p">
                      Upload Document
                      {/* <span style={{ color: "#ff0000" }}>*</span> */}
                    </Typography>
                    <div>
                      <input
                        type="file"
                        id="file_uploads"
                        name="file_uploads"
                        accept=".jpg,.jpeg,.webp,.png,.pdf,.doc,.docx,.xls,.xlsx"
                        onChange={(e) => setUploadedFile(e.target.files[0])}
                      />
                    </div>
                    <Box mt={2}>
                      {uploadeFile &&
                        Array.from(uploadeFile).map((file, idx) => (
                          <Box
                            key={idx}
                            display="flex"
                            alignItems="center"
                            mb={1}
                            style={{ gap: "10px" }}
                          >
                            {file.type.startsWith("image/") ? (
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                width={50}
                                height={50}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <Typography>{file.name}</Typography>
                            )}
                            <IconButton
                              color="primary"
                              onClick={() => {
                                const newFiles = Array.from(uploadeFile).filter(
                                  (_, i) => i !== idx
                                );
                                setUploadedFile(newFiles);
                              }}
                            >
                              <Delete />
                            </IconButton>
                          </Box>
                        ))}
                    </Box>
                  </li>
                  {uploadDocError && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Please upload valid document (should be less than 5 MB and
                      it must be images, PDF, Word, or Excel files).
                    </p>
                  )}
                  <li>
                    <Typography variant="p" style={{ marginTop: "-25px" }}>
                      Tags
                    </Typography>
                    <Box style={{ marginTop: "20px" }}>
                      {rows.map((row, index) => (
                        <Box
                          key={index}
                          display="flex"
                          alignItems="center"
                          mb={2}
                          style={{ gap: "10px" }}
                        >
                          <TextField
                            value={row.key}
                            onChange={(e) =>
                              handleInputChange(index, "key", e.target.value)
                            }
                            style={{ marginRight: "10px", flexGrow: 1 }}
                            className={classes.input}
                            placeholder="Key"
                          />
                          <TextField
                            value={row.value}
                            onChange={(e) =>
                              handleInputChange(index, "value", e.target.value)
                            }
                            className={classes.input}
                            style={{ flexGrow: 1 }}
                            placeholder="Value"
                          />
                          {rows.length > 1 && (
                            <IconButton
                              color="secondary"
                              onClick={() => deleteRow(index)}
                              aria-label="delete"
                            >
                              <Delete />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                      <Box className={classes.modalbtn}>
                        <IconButton
                          color="primary"
                          onClick={addNewRow}
                          aria-label="add new"
                        >
                          <AddCircleOutline />
                        </IconButton>
                      </Box>
                    </Box>
                  </li>
                  {/* {rowsError && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: ".875em",
                        marginTop: "0.25rem",
                        textAlign: "right",
                      }}
                    >
                      Rows data are mandatory
                    </p>
                  )} */}
                </ul>
              </form>
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.modalbtn}>
            {showLoader ? (
              <Loader
                type="ThreeDots"
                color="#000000"
                height={50}
                width={50}
                timeout={0} //30 secs
              />
            ) : (
              <Button
                size="large"
                className={classes.loginbtn}
                onClick={submit}
              >
                Submit
              </Button>
            )}
          </DialogActions>
        </Dialog>
        {/* View Modal */}
        {/* <Dialog
          className={classes.modal}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          disableEnforceFocus={true}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className={classes.ccmmodal}>
            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                fontFamily: "poppins",
                marginBottom: 30,
                fontWeight: "600",
              }}
            >
              View Documents
            </Typography>
            <Box className={classes.btncol}>
              <Button onClick={handleClose} className={classes.closebtn}>
                <BiXCircle className={classes.closeicon} />
              </Button>
            </Box>
            <DialogContentText id="alert-dialog-slide-description">
              {view ? (
                <ul className={classes.Editplan}>
                  <li className={classes.container}>
                    <Typography variant="p">
                      Name<span style={{ color: "#ff0000" }}>*</span> :
                    </Typography>
                    <Typography variant="p">
                      {`${view?.file_name}`.split(".")[0] ||
                        getTagValue(view.tags, "testname")}
                    </Typography>
                  </li>
                  <li className={classes.container}>
                    <Typography variant="p">
                      Uploaded By<span style={{ color: "#ff0000" }}>*</span> :
                    </Typography>
                    <Typography variant="p">{view?.uploaded_by}</Typography>
                  </li>
                  <li className={classes.container}>
                    <Typography>Instruction: </Typography>
                    <Typography variant="p">
                      {getTagValue(view.tags, "instructions")}
                    </Typography>
                  </li>
                  <li className={classes.container}>
                    <Typography variant="p">
                      Document Types<span style={{ color: "#ff0000" }}>*</span>:
                    </Typography>
                    <Typography variant="p">{view?.source}</Typography>
                  </li>

                  <li className={classes.container}>
                    <Typography variant="p">
                      Report Date<span style={{ color: "#ff0000" }}>*</span>:
                    </Typography>
                    <Typography variant="p">
                      {`${view?.report_date}`.split(" ")[0]}
                    </Typography>
                  </li>
                  <li className={classes.container1}>
                    <Typography variant="p">
                      Download Document
                      <span style={{ color: "#ff0000" }}>*</span>:
                    </Typography>
                    <Button
                      onClick={() => downloadFile(view.presigned_uri)}
                      size="large"
                      className={classes.loginbtn}
                    >
                      Download
                    </Button>
                  </li>
                  <li className={classes.container2}>
                    <Typography variant="p">Tags :</Typography>
                    <Box className={classes.tags}>
                      {view?.tags?.length > 0 ? (
                        view.tags.map((tag, index) => (
                          <Box
                            key={index}
                            display="flex"
                            alignItems="center"
                            style={{
                              gap: "10px",
                              marginBottom: "8px",
                            }}
                          >
                            <Typography
                              style={{
                                fontWeight: "500",
                                color: "#333",
                              }}
                            >
                              Key: {tag.key || "--"}
                            </Typography>
                            <Typography
                              style={{
                                fontWeight: "500",
                                color: "#555",
                              }}
                            >
                              Value: {tag.value || "--"}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Typography
                          style={{ fontWeight: "400", color: "#888" }}
                        >
                          No tags available
                        </Typography>
                      )}
                    </Box>
                  </li>
                </ul>
              ) : (
                <></>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.modalbtn}>
            {showLoader ? (
              <Loader
                type="ThreeDots"
                color="#000000"
                height={50}
                width={50}
                timeout={0} //30 secs
              />
            ) : (
              <Button
                size="large"
                className={classes.Deletebtn}
                onClick={handleClose}
              >
                Close
              </Button>
            )}
          </DialogActions>
        </Dialog> */}

        {/* Update Modal */}
        <Dialog
          className={classes.modal}
          open={isDocModalOpen2}
          TransitionComponent={Transition}
          keepMounted
          onClose={closeDocModal2}
          disableEnforceFocus={true}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className={classes.ccmmodal}>
            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                fontFamily: "poppins",
                marginBottom: 30,
                fontWeight: "600",
              }}
            >
              Update Documents
            </Typography>
            <Box className={classes.btncol}>
              <Button onClick={closeDocModal2} className={classes.closebtn}>
                <BiXCircle className={classes.closeicon} />
              </Button>
            </Box>
            <DialogContentText id="alert-dialog-slide-description">
              <ul className={classes.Editplan}>
                <li>
                  <Typography variant="p">
                    Documnet Name<span style={{ color: "#ff0000" }}>*</span>
                  </Typography>{" "}
                  <TextField
                    placeholder="please mention medication name"
                    className={classes.input}
                    onChange={(e) => setDocName2(e.target.value)}
                    value={docName2}
                    type="text"
                  />
                </li>
                {docNameError2 ? (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      textAlign: "right",
                    }}
                  >
                    Document name is mandatory(max character limit is 100)
                  </p>
                ) : (
                  <></>
                )}
                <li style={{ marginTop: 40 }}>
                  <Typography variant="p">
                    Upload Document
                    <span style={{ color: "#ff0000" }}>*</span>
                  </Typography>
                  <div>
                    <input
                      type="file"
                      id="file_uploads"
                      name="file_uploads"
                      accept=".jpg,.jpeg,.webp,.png,.pdf,.doc,.docx,.xls,.xlsx"
                      onChange={(e) => setUploadedFile2(e.target.files[0])}
                    />
                  </div>
                  <Box mt={2}>
                    {uploadedFile2 && (
                      <Box display="flex" alignItems="center" mt={2} gap="10px">
                        {uploadedFile2.type.startsWith("image/") ? (
                          <img
                            src={URL.createObjectURL(uploadedFile2)}
                            alt={uploadedFile2.name}
                            width={50}
                            height={50}
                            style={{ objectFit: "cover", borderRadius: "4px" }}
                          />
                        ) : (
                          <Typography>{uploadedFile2.name}</Typography>
                        )}
                        <IconButton
                          color="primary"
                          onClick={() => setUploadedFile2(null)}
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                </li>
                {uploadDocError2 && (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      textAlign: "right",
                    }}
                  >
                    Please upload valid document (should be less than 5 MB and
                    it must be images, PDF, Word, or Excel files).
                  </p>
                )}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.modalbtn}>
            {showLoader ? (
              <Loader
                type="ThreeDots"
                color="#000000"
                height={50}
                width={50}
                timeout={0} //30 secs
              />
            ) : (
              <Button
                size="large"
                className={`${classes.viewbtn} ${
                  loading ? classes.loading : 'background: "#0b3d6e",'
                }`}
                onClick={addDocumnet}
                disabled={loading}
              >
                submit
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
}

export default PatientDocument;
const useStyles = makeStyles(() => ({
  Pagecontent: {
    width: "100%",
    display: "flex",
    textAlign: "left",
  },
  TabPatientinfo: {
    "@media only screen and (max-width: 820px)": {
      display: "none",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  editbtn: {
    background: "#88b3eb",
    padding: "6px 8px",
    borderRadius: "10px",
    color: "#fff",
    cursor: "pointer",
  },
  // Deletebtn: {
  //   background: "#0f3d6e",
  //   padding: "6px 8px",
  //   borderRadius: "10px",
  //   color: "#fff",
  //   cursor: "pointer",
  // },
  Deletebtn: {
    background: "#fff",
    border: "1px #f12626 solid",
    width: "60px",
    height: "30px",
    color: "#f12626",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    "&:hover": {
      background: "#f12626",
      color: "#fff",
    },
  },
  Leftcol: {
    width: "22%",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
    padding: "20px 3%",
    position: "relative",
    minHeight: "1050px",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
      padding: "20px 1%",
    },
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
  },
  datepicker: {
    borderRadius: "10px !important",
    height: "45px",
    width: "96%",
    fontFamily: "Poppins",
    fontSize: "14px",
    background: "#F9F9F9",
    border: "1px solid #D5D5D5 !important",
    paddingLeft: 15,
    "&:focus": {
      border: "1px #0f3d6e solid !important",
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  Rightcol: {
    width: "78%",
    padding: "20px 3%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 1200px)": {
      width: "72%",
      padding: "0 1%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minHeight: "40px",
    },
  },
  Careplan: {
    width: "100%",
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #e3e5e5 solid",
      height: "auto",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0px",
    },
    "& .MuiAccordionSummary-content": {
      margin: "0",
      order: "2",
      width: "100%",
    },
    "& .MuiIconButton-root": {
      padding: "5px",
      fontSize: "16px",
      marginRight: "5px",
      color: "#88b3eb",
      position: "absolute",
      left: "-25px",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
  },
  topheading: {
    fontSize: "18px",
    color: "#000",
    fontWeight: "500",
  },
  Filter: {
    textAlign: "left",
    margin: "5px 0 20px 0",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  Editbtn: {
    background: "#fff",
    border: "1px #AEAEAE solid",
    width: "60px",
    height: "30px",
    color: "#0f3d6e",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    "&:hover": {
      background: "#0f3d6e",
      color: "#fff",
    },
  },

  icon: {
    color: "#0f3d6e",
    fontSize: "20px",
    marginRight: "10px",
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px #E3E5E5 solid",
    alignItems: "center",
    fontSize: "13px",
    lineHeight: "16px",
    color: "#ffffff",
    padding: 12,
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    width: "98%",
    alignItems: "center",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1000,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "0px #E3E5E5 solid",
    fontSize: "12px",
    padding: "10px 0",
    width: "100%",
    alignItems: "center",
    lineHeight: "15px",
    color: "#000",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1000,
      },
  },
  Row1: {
    width: "12.5%",
    wordWrap: "break-word",
    paddingRight: "0.5%",
    paddingLeft: 10,
  },
  Row2: {
    width: "12.5%",
    paddingRight: "0.5%",
    textAlign: "center",
  },
  Row3: {
    width: "16.5%",
    paddingRight: "0.5%",
    wordWrap: "break-word",
    textAlign: "center",
  },
  Row4: {
    width: "12.5%",
    paddingRight: "0.5%",
  },
  Row5: {
    width: "14.5%",
    paddingRight: "0.5%",
    wordWrap: "break-word",
  },
  modal: {
    "& .MuiPaper-rounded": {
      borderRadius: "10px !important",
      padding: "20px",
      width: "776px",
      maxWidth: "776px",
    },
    "& .MuiFormControlLabel-label": {
      flex: "0 0 220px !important",
    },
    "& .MuiTypography-root": {
      fontSize: 14,
      fontFamily: "poppins",
    },
    "& .MuiBox-root": {
      width: "78%",
    },
  },
  ccmmodal: {
    borderRadius: "10px",
    "& .react-date-picker__wrapper": {
      borderRadius: 10,
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 10px",
    },
    "& .react-date-picker__inputGroup__input:focus": {
      border: 0,
      boxShadow: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
  },
  modalbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "30px",
    marginLeft: "15px",
    alignItems: "center",
  },
  input: {
    border: "none",
    borderRadius: "10px",
    height: "42px",
    width: "100%",
    fontFamily: "Poppins",
    fontSize: "12px",
  },
  Editplan: {
    listStyle: "none",
    margin: "0px",
    padding: "0px",
    alignItems: "center",
    "& li": {
      display: "flex",
      fontSize: "14px",
      alignItems: "center",
      marginBottom: "15px",
      position: "relative",
      "& .MuiTypography-root": {
        flex: "0 0 150px",
        color: "#121212",
        margin: "0px",
      },
    },
    "& span": {},
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "42px",
    },
    "& .MuiInputBase-input": {
      height: "42px",
      borderRadius: "10px",
      background: "#F9F9F9",
      border: "1px solid #D5D5D5",
      padding: "0 15px",
      fontFamily: "Poppins",
      fontSize: "12px",
      color: "#000",
    },
    "& .MuiInputBase-input:focus": {
      border: "1px #0f3d6e solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
  },
  loginbtn: {
    background: "#0f3d6e",
    padding: "0 40px",
    width: "150px",
    height: "40px",
    borderRadius: "10px",
    color: "#fff",
    marginTop: "20px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#333",
    },
  },
  viewbtn: {
    background: "#0f3d6e",
    padding: "0 40px",
    width: "90px",
    height: "40px",
    borderRadius: "10px",
    color: "#fff",
    marginTop: "20px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#333",
    },
  },
  btncol: {
    display: "flex",
    justifyContent: "flex-end",
  },
  closebtn: {
    width: "40px",
    position: "absolute",
    right: "10px",
    height: "40px",
    background: "#fff",
    top: "10px",
    minWidth: "40px",
    "&:hover": {
      background: "#fff",
    },
  },
  closeicon: {
    fontSize: "25px",
    color: "#0f3d6e",
  },
  plantop: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    marginTop: "10px",
  },
  recordbtn: {
    background: "#fff",
    fontSize: "16px",
    color: "#0f3d6e",
    textTransform: "capitalize",
    "&:hover": {
      background: "#fff",
    },
  },
  addicon: {
    fontSize: "20px",
    color: "#0f3d6e",
    marginRight: "10px",
  },
  Tabcol: {
    "& .MuiTabPanel-root": {
      padding: "0px",
    },
  },

  MedicationTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  container: {
    display: "flex",
    justifyContent: "space-around",
  },
  container1: {
    display: "flex",
    justifyContent: "space-around",
    paddingRight: 30,
  },
  container2: {
    display: "flex",
    justifyContent: "space-around",
    marginLeft: "15%",
  },
  tags: {
    marginTop: "30px",
    marginLeft: "18%",
  },
  text: {
    fontWeight: "normal",
    fontSize: "12px",
    color: "red",
  },
  select: {
    width: "100% !important",
    border: "none !important",
    borderRadius: "10px !important",
    background: "#F9F9F9",
    height: "50px",
    fontSize: "14px !important",
    paddingLeft: "15px !important",
    paddingRight: "15px !important",
  },
}));
